export const WEBSOCKET_FAIL = 'WEBSOCKET/FAIL'

export const WEBSOCKET_OPEN_USER = 'WEBSOCKET/START_USER_CHANNEL'
export const WEBSOCKET_CLOSE_USER = 'WEBSOCKET/CLOSE_USER_CHANNEL'